import { toAbsolutePublicUrl } from "../../../services/mediaLibraryServices";

export const FALLBACK_PROJET_IMAGE = "/img/no-image.jpg";

export function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function ensureArray(value) {
  return Array.isArray(value) ? value : [];
}

export function toBoolean(value) {
  return value === true || value === 1 || value === "1";
}

export function stripHtml(html = "") {
  return String(html)
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function truncateText(value = "", maxLength = 180) {
  const text = String(value || "").trim();
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength - 1).trim()}…`;
}

export function normalizeSearchText(value = "") {
  return String(value || "")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();
}

export function parseDate(value) {
  if (!value) return null;

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDate(value) {
  const date = parseDate(value);
  if (!date) return "";

  return date.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}

export function resolveProjetImage(value) {
  const image = String(value || "").trim();

  if (!image) return FALLBACK_PROJET_IMAGE;
  if (/^https?:\/\//i.test(image)) return image;
  if (image.startsWith("/")) return image;

  return toAbsolutePublicUrl(image) || FALLBACK_PROJET_IMAGE;
}

export function getProjetDate(projet) {
  return projet?.updated_at || projet?.created_at || "";
}

export function isActiveProjet(projet) {
  return toBoolean(projet?.is_active);
}

export function normalizeProjet(projet) {
  const title = projet?.titre || "Projet";
  const descriptionRaw = projet?.description || "";
  const descriptionText = stripHtml(descriptionRaw);
  const dateValue = getProjetDate(projet);
  const dateLabel = formatDate(dateValue);
  const updatedLabel = projet?.updated_at ? formatDate(projet.updated_at) : "";
  const createdLabel = projet?.created_at ? formatDate(projet.created_at) : "";

  const normalized = {
    id: projet?.id,
    raw: projet,

    title,
    descriptionRaw,
    descriptionText,
    excerpt: truncateText(descriptionText, 190),

    dateValue,
    dateLabel,
    updatedLabel,
    createdLabel,

    image: resolveProjetImage(projet?.image_projet_url),
    imageAlt: title,

    sortDate: parseDate(dateValue)?.getTime() || 0,
  };

  normalized.searchIndex = normalizeSearchText(
    [normalized.title, normalized.descriptionText, normalized.dateLabel]
      .filter(Boolean)
      .join(" ")
  );

  return normalized;
}

export function sortProjets(items) {
  return [...items].sort((a, b) => {
    if (a.sortDate !== b.sortDate) {
      return b.sortDate - a.sortDate;
    }

    return normalizeSearchText(a.title).localeCompare(
      normalizeSearchText(b.title),
      "fr"
    );
  });
}